// covered-by: qa/rickrubin/tests/specs/cca/ask.puntt.sidebar.spec.ts
// eslint-disable-next-line import/named
import { createRoute, redirect } from "@tanstack/react-router";

import AskPunttChats from "./chats";
import { parseLauncherSearch } from "./launcherSearch";

import PendingComponent from "../../components/PendingComponent";
import { canAccessAskPuntt } from "../../utils/auth";
import { authLayoutRoute } from "../auth-layout/route";
import { ticketsRoute } from "../tickets/route";

export { launcherSearch } from "./launcherSearch";

export const askPunttChatsRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: "ask-puntt/chats",
  validateSearch(search: Record<string, unknown>) {
    return parseLauncherSearch(search);
  },
  beforeLoad() {
    if (!canAccessAskPuntt()) {
      throw redirect({ to: ticketsRoute.to });
    }
  },
  component: AskPunttChats,
  pendingComponent: PendingComponent,
  gcTime: 0,
  shouldReload: true,
  pendingMs: 0,
  pendingMinMs: 500,
});
